import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.914 34.914 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Zm31.358-10.666H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16.004 11.333c.07 0 .14.002.21.005a.333.333 0 0 1-.03.666 4.135 4.135 0 0 0-.62.02.333.333 0 1 1-.071-.663c.168-.019.337-.028.511-.028Zm1.916.412a4.62 4.62 0 0 0-.675-.244.333.333 0 1 0-.178.643c.198.055.392.124.579.209a.333.333 0 0 0 .274-.607Zm.957.58c.188.148.365.31.529.485a.333.333 0 0 1-.486.455 4.02 4.02 0 0 0-.455-.415.333.333 0 1 1 .412-.525Zm1.485 2.013a4.636 4.636 0 0 0-.307-.65.333.333 0 1 0-.579.331c.102.178.19.364.263.556a.333.333 0 1 0 .623-.237Zm.305 1.716-.001.053a.333.333 0 1 1-.667-.015v-.045l.001-.045c0-.178-.011-.354-.034-.527a.333.333 0 0 1 .661-.086c.027.201.04.405.04.613v.052Zm-.368 1.766c.093-.22.17-.448.228-.681a.333.333 0 0 0-.647-.163c-.05.2-.115.395-.195.584a.333.333 0 0 0 .614.26Zm-.564.978a4.69 4.69 0 0 1-.473.54.333.333 0 1 1-.466-.477 4.01 4.01 0 0 0 .406-.463.333.333 0 1 1 .533.4Zm-1.973 1.525c.222-.091.437-.199.642-.322a.333.333 0 0 0-.344-.571c-.176.105-.36.198-.55.275a.333.333 0 0 0 .252.618ZM16 20.667A.333.333 0 0 1 16 20c-.094 0-.187-.003-.28-.01a.333.333 0 1 0-.045.666c.108.007.216.01.325.01ZM16 20c.208 0 .413-.016.614-.047a.333.333 0 0 1 .102.66 4.69 4.69 0 0 1-.716.054.333.333 0 0 0 0-.667Zm-1.562-8.399c-.226.08-.446.178-.656.292a.333.333 0 1 0 .317.587c.18-.098.368-.182.562-.25a.333.333 0 0 0-.223-.629Zm-2.08 1.48a4.69 4.69 0 0 1 .491-.523.333.333 0 1 1 .45.491c-.151.14-.292.29-.42.45a.333.333 0 1 1-.52-.418Zm-.566.9c-.104.216-.191.44-.26.67a.333.333 0 0 0 .638.192c.06-.197.134-.388.223-.573a.333.333 0 1 0-.601-.289ZM11.334 16c0-.096.002-.191.008-.287a.333.333 0 1 1 .666.04 4.112 4.112 0 0 0 .007.593.333.333 0 0 1-.664.057 4.69 4.69 0 0 1-.018-.403Zm.233 1.462c.075.228.168.45.277.663a.333.333 0 1 0 .594-.304 3.972 3.972 0 0 1-.238-.568.333.333 0 1 0-.633.21Zm1.428 2.108a4.695 4.695 0 0 1-.512-.503.333.333 0 0 1 .502-.438c.135.155.282.299.44.431a.333.333 0 1 1-.43.51Zm.889.59c.213.109.434.201.663.276a.333.333 0 0 0 .207-.634 3.955 3.955 0 0 1-.568-.236.333.333 0 0 0-.303.594Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M16 13.333 18.667 18h-5.334L16 13.333Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagNic = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNic_default = SvgFlagNic;

export { FlagNic_default as default };
